import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "m7.205 26.5 1.486-4.382c-1.284-1.867-1.749-4.078-1.307-6.221.441-2.144 1.759-4.075 3.707-5.434 1.949-1.359 4.395-2.053 6.886-1.954 2.49.1 4.854.986 6.653 2.494 1.799 1.508 2.91 3.536 3.126 5.706.216 2.17-.477 4.334-1.95 6.091-1.474 1.758-3.627 2.987-6.06 3.461-2.434.474-4.98.16-7.169-.884L7.205 26.5",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "m12.92 18.635 3.429-2.247 2.286 2.247 3.429-2.247",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgMessenger;